import { v4 as uuidv4 } from 'uuid';
import SampleInfo from './sample-info';
const samplesData = [
    {
        name: 'Ahhh',
        url: '/samples/ahhhh-tip.mp3',
    },
    // {
    //     name: 'Ahhhh',
    //     url: '/samples/ahhhh.mp3',
    // },
    {
        name: 'Bam',
        url: '/samples/bam.mp3',
    },
    // {
    //     name: 'One Two Three',
    //     url: '/samples/one-two-three-simple.mp3',
    //     segments: 3,
    // },
    {
        name: 'One Two Three Four',
        url: '/samples/1234.mp3',
    },
    {
        name: 'Rock the Beat',
        url: '/samples/rockthebeat.mp3',
    },
    {
        name: 'Scratch',
        url: '/samples/scratch.mp3',
    },
    {
        name: 'Uuuhh',
        url: '/samples/uuuuhh.mp3',
    },
    {
        name: 'Yeah',
        url: '/samples/yeah.mp3',
    },
    {
        name: 'Yoo',
        url: '/samples/yoo.mp3',
    },
];
const sampleInfoCollection = new Map();
// init
for (const sampleData of samplesData) {
    const id = uuidv4();
    const sampleInfo = new SampleInfo(id, sampleData.name, sampleData.url);
    sampleInfoCollection.set(id, sampleInfo);
}
const getSampleInfoById = (id) => {
    return sampleInfoCollection.get(id);
};
export default sampleInfoCollection;
export { sampleInfoCollection, getSampleInfoById, };
